import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
    class: "cell-image"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_el_radio = _resolveComponent("el-radio");
    const _component_el_table_column = _resolveComponent("el-table-column");
    const _component_el_avatar = _resolveComponent("el-avatar");
    const _component_scTable = _resolveComponent("scTable");
    const _directive_loading = _resolveDirective("loading");
    return _withDirectives((_openBlock(), _createBlock(_component_scTable, {
        ref: "table",
        data: $data.tableData,
        staticTotal: $data.total,
        height: "470px",
        pageSize: $data.queryInfo.pageSize,
        stripe: "",
        onPaginationChange: $options.paginationChange,
        onPageSizeChange: $options.pageSizeChange,
        "select-on-indeterminate": false
    }, {
        default: _withCtx(()=>[
                _createVNode(_component_el_table_column, {
                    label: "#",
                    width: "55"
                }, {
                    default: _withCtx(({ row })=>[
                            _createVNode(_component_el_radio, {
                                value: `/packageGoods/detail/index?id=${row.id}`,
                                modelValue: $data.url,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.url = $event)
                            }, {
                                default: _withCtx(()=>[
                                        ..._cache[1] || (_cache[1] = [
                                            _createTextVNode("  ", -1)
                                        ])
                                    ]),
                                _: 1
                            }, 8, [
                                "value",
                                "modelValue"
                            ])
                        ]),
                    _: 1
                }),
                _createVNode(_component_el_table_column, {
                    label: "商品图",
                    width: "100",
                    align: "center"
                }, {
                    default: _withCtx((scope)=>[
                            _createElementVNode("div", _hoisted_1, [
                                _createVNode(_component_el_avatar, {
                                    src: scope.row.image
                                }, null, 8, [
                                    "src"
                                ])
                            ])
                        ]),
                    _: 1
                }),
                _createVNode(_component_el_table_column, {
                    label: "商品名称",
                    prop: "title",
                    align: "center",
                    "min-width": "150"
                })
            ]),
        _: 1
    }, 8, [
        "data",
        "staticTotal",
        "pageSize",
        "onPaginationChange",
        "onPageSizeChange"
    ])), [
        [
            _directive_loading,
            $data.isLoading
        ]
    ]);
}
